export default __webpack_public_path__ + "static/media/la_capelle4.b43ef929.jpg";